import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ЗАМЕНИТЕ ЭТИ ДАННЫЕ НА ВАШИ ИЗ КОНСОЛИ FIREBASE!
const firebaseConfig = {
  apiKey: "AIzaSyCOZoBmSYHDnusLkgxM9OkNd0XV-x6D2rk",
  authDomain: "my-soc-net-666.firebaseapp.com",
  projectId: "my-soc-net-666",
  storageBucket: "my-soc-net-666.firebasestorage.app",
  messagingSenderId: "591854636431",
  appId: "1:591854636431:web:fa4487a389d6a9b4940ffa"
};
// Инициализация Firebase
const app = initializeApp(firebaseConfig);

// Экспортируем сервисы, которые будем использовать
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);